import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { any, objectOf } from 'prop-types';
import {
  Tabela,
  Filtros,
  Header,
  BotaoPrimario,
  BotaoDefault,
} from '../../components/layout';
import { MaquinaForm } from '../../components/forms';
import { useApi, useUrl } from '../../hooks';
import { ModalBusca } from '../../components/modais';
import { Container } from '../styles';
import { MAQUINAS } from '../../components/layout/Tabela/nomesCabecalhos';
import { MAQUINA_LAYOUT } from '../../components/layout/Filtros/nomeFiltros';
import { EXCLUIR } from '../../components/layout/Tabela/nomesAcoes';
import { telaGrande } from '../../utils';
import {
  CADASTRAR,
  FILTRAR,
  ATIVAR_FILTRO,
  BUSCAR,
  MAQUINA,
} from '../../hooks/useUrl/acoes';

const { Tags, TituloComFiltro } = Filtros;

const Maquinas = ({ history }) => {
  const { deletar, buscar } = useApi();
  const { existeQuery, adicionarQuery, removerQuery, pegarValorQuery } = useUrl(
    history,
  );
  const [filtro, setFiltro] = useState('');
  const [maquinas, setMaquinas] = useState([]);
  const busca = pegarValorQuery(BUSCAR);
  const mostrarCadastro = existeQuery(CADASTRAR, MAQUINA);
  const { loading } = useSelector(({ reducer }) => reducer, shallowEqual);

  const [pagina, setPagina] = useState(1);

  const deletarMaquina = async ({ uid, nome, codigo }) => {
    await deletar(
      `/maquinas/${uid}`,
      `Máquina ${codigo} - ${nome} excluída com sucesso!`,
      () =>
        setMaquinas(
          maquinas.filter(({ uid: maquinaUid }) => maquinaUid !== uid),
        ),
    );
  };

  useEffect(() => {
    const carregarMaquinas = async () => {
      if (pagina === 1) {
        setMaquinas([]);
      }

      if (filtro === '') {
        const { data } = await buscar(
          `/maquinas?${filtro}${
            busca ? `&$buscar=${busca}` : ''
          }&$ordem=nome,uid&$limite=10&$pagina=${pagina}`,
        );
        setMaquinas(maquina => [...maquina, ...data]);
      }

      if (filtro !== '') {
        const { data } = await buscar(
          `/maquinas?${filtro}${
            busca ? `&$buscar=${busca}` : ''
          }&$ordem=nome,uid&`,
        );
        setMaquinas(data);
        setPagina(1);
      }
    };
    carregarMaquinas();
  }, [buscar, filtro, busca, pagina]);

  const retornarQuery = query => filtro !== query && setFiltro(query);

  useEffect(() => {
    if (filtro === '') {
      const intersectionObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          setPagina(page => page + 1);
        }
      });

      intersectionObserver.observe(document.querySelector('#final'));
      return () => intersectionObserver.disconnect();
    }

    return undefined;
  }, [filtro]);

  return (
    <Container>
      <Header
        transparente
        semPadding="true"
        title={
          <TituloComFiltro
            titulo="Máquinas de Costura"
            history={history}
            busca={busca}
          />
        }
        extra={[
          <BotaoDefault
            disabled={loading}
            key="1"
            htmlType="button"
            onClick={() => adicionarQuery(FILTRAR, ATIVAR_FILTRO)}
          >
            Filtrar
          </BotaoDefault>,
          <BotaoPrimario
            disabled={loading}
            key="2"
            type="primary"
            htmlType="button"
            onClick={() => adicionarQuery(CADASTRAR, MAQUINA)}
          >
            Nova máquina
          </BotaoPrimario>,
        ]}
      />
      <Tags retornarQuery={retornarQuery} history={history} />
      <Tabela
        cabecalho={MAQUINAS}
        dados={maquinas}
        loading={loading}
        celulaSelecionada={({ uid }) => history.push(`/maquinas/${uid}`)}
        acoes={
          telaGrande()
            ? [{ titulo: EXCLUIR, onClick: deletarMaquina, confirmacao: true }]
            : null
        }
      />

      <MaquinaForm
        mostrar={mostrarCadastro}
        aoFechar={() => removerQuery(CADASTRAR, MAQUINA)}
        afterSubmit={maquina => {
          if (maquina) {
            setMaquinas([...maquinas, maquina]);
            removerQuery(CADASTRAR, MAQUINA);
          }
        }}
      />

      <ModalBusca
        retornarQuery={retornarQuery}
        history={history}
        nomeFiltro={MAQUINA_LAYOUT}
      />
      {filtro === '' ? <div id="final" /> : null}
    </Container>
  );
};

Maquinas.propTypes = {
  history: objectOf(any).isRequired,
};

export default Maquinas;
